import { articles } from '@/mocks/articles';
import { useNavigate } from 'react-router-dom';

export default function ArticlePreview() {
  const navigate = useNavigate();

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-12">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
              PandaBuy Sheet<br />Guides &amp; Tips
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-500 max-w-md">
            Expert-written articles to help you master the art of spreadsheet shopping. From beginner guides to advanced strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {articles.map((article) => (
            <article
              key={article.slug}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(`/article/${article.slug}`);
              }}
              className="group rounded-2xl overflow-hidden bg-background-100 cursor-pointer hover:bg-background-200/70 transition-colors duration-300"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`PandaBuy Spreadsheet Guide - ${article.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}